export const SectionFourDocTypeTypes = {
  REGULATION_DOC: "REGULATION_DOC", // Нормативные документы
  SUPPORTING_DOC: "SUPPORTING_DOC", // Сопроводительные документы
  VARIANT_DOC: "VARIANT_DOC", // Вариантные документы
  PROJECT_DOC: "PROJECT_DOC", // Проектная документация
  WORK_DOC: "WORK_DOC", // Рабочая документация
  BUILT_SCHEME: "BUILT_SCHEME", // Исполнительная схема
  BUILT_BLUEPRINT: "BUILT_BLUEPRINT", // Исполнительный чертеж
  LABORATORYDATA_DOC: "LABORATORYDATA_DOC", // Лабораторные документы
} as const;

export type SectionFourDocTypeEnum = (typeof SectionFourDocTypeTypes)[keyof typeof SectionFourDocTypeTypes];

export const sectionFourDocTypeToEndpointMap: Record<SectionFourDocTypeEnum, string> = {
  [SectionFourDocTypeTypes.REGULATION_DOC]: "normative",
  [SectionFourDocTypeTypes.SUPPORTING_DOC]: "supporting",
  [SectionFourDocTypeTypes.VARIANT_DOC]: "supporting",
  [SectionFourDocTypeTypes.PROJECT_DOC]: "workingdraft",
  [SectionFourDocTypeTypes.WORK_DOC]: "workingdraft",
  [SectionFourDocTypeTypes.BUILT_SCHEME]: "executivescheme",
  [SectionFourDocTypeTypes.BUILT_BLUEPRINT]: "executivedrawing",
  [SectionFourDocTypeTypes.LABORATORYDATA_DOC]: "laboratorydata",
};

export const sectionFourDocTypeUsesPost: Record<SectionFourDocTypeEnum, boolean> = {
  [SectionFourDocTypeTypes.REGULATION_DOC]: false,
  [SectionFourDocTypeTypes.SUPPORTING_DOC]: false,
  [SectionFourDocTypeTypes.VARIANT_DOC]: false,
  [SectionFourDocTypeTypes.PROJECT_DOC]: false,
  [SectionFourDocTypeTypes.WORK_DOC]: false,
  [SectionFourDocTypeTypes.BUILT_SCHEME]: false,
  [SectionFourDocTypeTypes.BUILT_BLUEPRINT]: true,
  [SectionFourDocTypeTypes.LABORATORYDATA_DOC]: false,
};

export const sectionFourDocTypeEndpoints: Record<SectionFourDocTypeEnum, string> = {
  [SectionFourDocTypeTypes.REGULATION_DOC]: "normative",
  [SectionFourDocTypeTypes.SUPPORTING_DOC]: "supporting",
  [SectionFourDocTypeTypes.VARIANT_DOC]: "supporting",
  [SectionFourDocTypeTypes.PROJECT_DOC]: "workingdraft",
  [SectionFourDocTypeTypes.WORK_DOC]: "workingdraft",
  [SectionFourDocTypeTypes.BUILT_SCHEME]: "executivescheme",
  [SectionFourDocTypeTypes.BUILT_BLUEPRINT]: "executivedrawing",
  [SectionFourDocTypeTypes.LABORATORYDATA_DOC]: "laboratorydata",
};

export const sectionFourDocTypeListEndpoints: Record<SectionFourDocTypeEnum, string> = {
  [SectionFourDocTypeTypes.REGULATION_DOC]: "normative",
  [SectionFourDocTypeTypes.SUPPORTING_DOC]: "supporting",
  [SectionFourDocTypeTypes.VARIANT_DOC]: "supporting",
  [SectionFourDocTypeTypes.PROJECT_DOC]: "workingdraft",
  [SectionFourDocTypeTypes.WORK_DOC]: "workingdraft",
  [SectionFourDocTypeTypes.BUILT_SCHEME]: "executivescheme",
  [SectionFourDocTypeTypes.BUILT_BLUEPRINT]: "executivedrawing/search",
  [SectionFourDocTypeTypes.LABORATORYDATA_DOC]: "laboratorydata",
};

export const sectionFourDocTypeToOldTab: Record<SectionFourDocTypeEnum, string> = {
  [SectionFourDocTypeTypes.REGULATION_DOC]: "permit", // Разрешительная документация
  [SectionFourDocTypeTypes.SUPPORTING_DOC]: "supporting", // Сопроводительная документация
  [SectionFourDocTypeTypes.VARIANT_DOC]: "supporting", // Вариантные документы используют supporting
  [SectionFourDocTypeTypes.PROJECT_DOC]: "working_draft", // Проекты
  [SectionFourDocTypeTypes.WORK_DOC]: "working_draft", // Рабочая документация
  [SectionFourDocTypeTypes.BUILT_SCHEME]: "executive_scheme", // Исполнительные схемы
  [SectionFourDocTypeTypes.BUILT_BLUEPRINT]: "executive_drawing", // Исполнительный чертеж
  [SectionFourDocTypeTypes.LABORATORYDATA_DOC]: "laboratory", // Лаборатория
};
